import React from 'react';

export default class ProviderDocDetails extends React.Component {
     constructor(props) {
        super(props);
        this.state = {  
           
        }
    };


    render() {

        return (
             <div>
                {(this.props.details) && (
                    <div>
                        <h5><b>Years In Practice</b></h5>
                    <p>{ this.props.details.YearsInPractice } </p>

                    <h5><b>Primary Specialty</b></h5>
                    <p>{ this.props.details.PrimarySpecialty } </p>
                
                
                    {(this.props.details.SecondarySpecialty) && (
                        <div>
                            <h5><b>Secondary Specialty</b></h5>
                            <p>{ this.props.details.SecondarySpecialty } </p>
                        </div>
                    )}

                    {(this.props.details.MedicalSchool !== "") && (
                        <div>
                            <h5><b>Medical School</b></h5>
                            <p>{ this.props.details.MedicalSchool } </p>
                        </div>
                    )}
                </div>
                )}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Components/ProviderDocDetails.js